import type { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdIntlHlwn70 } from './pages'

type TIdToPageMapIntlHlwn70 = Record<PageIdIntlHlwn70, TPageMapValue>

export const ID_TO_PAGE_MAP_INTL_HLWN70: TIdToPageMapIntlHlwn70 = {
  [PageIdIntlHlwn70.OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/offer/OfferPage').then((m) => ({
        default: m.OfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_hlwn70/pages/offer/OfferPage'),
  },
  [PageIdIntlHlwn70.SPECIAL_DISCOUNT]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/specialDiscount/SpecialDiscountPage').then(
        (m) => ({
          default: m.SpecialDiscountPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_hlwn70/pages/specialDiscount/SpecialDiscountPage'),
  },
  [PageIdIntlHlwn70.CANCEL_OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/cancelOffer/CancelOfferPage').then(
        (m) => ({
          default: m.CancelOfferPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_hlwn70/pages/cancelOffer/CancelOfferPage'),
  },
  [PageIdIntlHlwn70.PAYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/payment/PaymentPage').then((m) => ({
        default: m.PaymentPage,
      })),
    ),
    preload: () => import('cohorts/intl_hlwn70/pages/payment/PaymentPage'),
  },
  [PageIdIntlHlwn70.CHECKOUT]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/checkout/CheckoutPage').then((m) => ({
        default: m.CheckoutPage,
      })),
    ),
    preload: () => import('cohorts/intl_hlwn70/pages/checkout/CheckoutPage'),
  },
  [PageIdIntlHlwn70.UPSELL]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/upsell/UpsellPage').then((m) => ({
        default: m.UpsellPage,
      })),
    ),
    preload: () => import('cohorts/intl_hlwn70/pages/upsell/UpsellPage'),
  },
  [PageIdIntlHlwn70.REGISTRATION]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('cohorts/intl_hlwn70/pages/account/AccountNove8'),
  },
  [PageIdIntlHlwn70.NAME_ENTRY]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/name/NamePage').then((m) => ({
        default: m.NamePage,
      })),
    ),
    preload: () => import('cohorts/intl_hlwn70/pages/name/NamePage'),
  },
  [PageIdIntlHlwn70.CERTIFICATE]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/certificate/CertificatePage').then(
        (m) => ({
          default: m.CertificatePage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_hlwn70/pages/certificate/CertificatePage'),
  },
  [PageIdIntlHlwn70.LEARNWORLDS_REDIRECT]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/learnWorldsRedirect/LearnWorldsRedirectPage').then(
        (m) => ({
          default: m.LearnWorldsRedirectPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_hlwn70/pages/learnWorldsRedirect/LearnWorldsRedirectPage'),
  },
  [PageIdIntlHlwn70.REPORT]: {
    Component: lazy(() =>
      import('cohorts/intl_hlwn70/pages/report/ReportPage').then((m) => ({
        default: m.ReportPage,
      })),
    ),
    preload: () => import('cohorts/intl_hlwn70/pages/report/ReportPage'),
  },
}
